import PropTypes from 'prop-types';

const locationProps = PropTypes.shape({
  hash: PropTypes.string,
  key: PropTypes.string,
  pathname: PropTypes.string,
  search: PropTypes.string,
  state: PropTypes.shape({}),
});

export default locationProps;
